import { cx } from '../cx';
import { percentOf } from './scale';

export type SparklineProps = {
  /** Oldest first. */
  values: number[];
  className?: string;
};

/**
 * A tiny line that shows direction inside a row. Never alone: the words beside it ("Up 8 in 8
 * weeks") carry the meaning and are what screen readers read, so the line is decorative.
 */
export function Sparkline({ values, className }: SparklineProps) {
  if (values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const y = (v: number) => 100 - (max === min ? 50 : percentOf(v, min, max));
  const x = (i: number) => (i / (values.length - 1)) * 100;
  const points = values.map((v, i) => `${x(i)},${y(v)}`).join(' ');
  const last = values[values.length - 1];
  return (
    <span aria-hidden="true" className={cx('relative inline-block h-6 w-24 shrink-0', className)}>
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 size-full overflow-visible">
        <polyline
          points={points}
          fill="none"
          vectorEffect="non-scaling-stroke"
          strokeWidth={1.5}
          strokeLinejoin="round"
          strokeLinecap="round"
          className="stroke-jc-ink-secondary"
        />
      </svg>
      <span
        className="absolute size-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-jc-ink"
        style={{ left: '100%', top: `${y(last)}%` }}
      />
    </span>
  );
}
